export default "__VITE_ASSET__KzlgvlRU__"